import styled from "styled-components";

export const Description = styled.p`
  margin: 0 0 16px;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 14px;
  line-height: 1.5;
`;

export const Notes = styled.textarea`
  width: 100%;
  min-height: 220px;
  margin-top: 12px;
  padding: 10px 12px;
  resize: vertical;
  border: 1px solid ${({ theme }) => theme.grey};
  border-radius: 6px;
  background: transparent;
  color: ${({ theme }) => theme.textMain};
  font: inherit;
  font-size: 14px;
  line-height: 1.5;
`;

export const StatusBlock = styled.div`
  padding: 8px 0;
  color: ${({ theme }) => theme.textMain};
  font-size: 14px;
  line-height: 1.5;
`;

export const Hint = styled.p`
  margin: 8px 0 0;
  color: ${({ theme }) => theme.textSecondary};
  font-size: 13px;
  line-height: 1.5;
`;

export const ErrorList = styled.ul`
  margin: 8px 0 0;
  padding-left: 18px;
  color: ${({ theme }) => theme.red};
  font-size: 13px;
  line-height: 1.6;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
`;
